/* src/app/core/authentication/register/register.component.scss */
.fct-register-page {
  display: flex;
  height: 100vh;
  font-family:
    "Inter Tight",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  background: #1d2530;
  position: relative;
  overflow: hidden;
}
.fct-brand {
  flex: 0 0 45%;
  background: #1d2530;
  background-image:
    radial-gradient(
      circle,
      rgba(255, 255, 255, 0.055) 1px,
      transparent 1px);
  background-size: 28px 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 56px 52px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.fct-brand::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background:
    linear-gradient(
      90deg,
      transparent 0%,
      rgba(227, 253, 100, 0.6) 40%,
      rgba(227, 253, 100, 0.6) 60%,
      transparent 100%);
}
@media (max-width: 860px) {
  .fct-brand {
    display: none;
  }
}
.fct-brand__inner {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.fct-brand__top {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.fct-brand__logo {
  height: 70px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
  align-self: flex-start;
  opacity: 0.92;
  animation: fct-up 0.6s ease both;
}
.fct-brand__label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: rgba(255, 255, 255, 0.28);
  text-transform: uppercase;
  animation: fct-up 0.6s ease 0.04s both;
}
.fct-brand__copy {
  animation: fct-up 0.6s ease 0.08s both;
}
.fct-brand__headline {
  font-family:
    "Bricolage Grotesque",
    "Inter Tight",
    sans-serif;
  font-size: 38px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.94);
  line-height: 1.14;
  letter-spacing: -0.035em;
  margin: 0 0 14px;
}
.fct-brand__tagline {
  font-size: 14.5px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.42);
  line-height: 1.65;
  margin: 0;
}
.fct-steps {
  position: relative;
  padding: 4px 0 2px;
  animation: fct-up 0.6s ease 0.12s both;
}
.fct-steps__track {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  overflow: hidden;
}
.fct-steps__fill {
  height: 100%;
  width: 0%;
  background:
    linear-gradient(
      90deg,
      #e3fd64,
      #f4fe9e);
  border-radius: 999px;
}
.fct-steps__row {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.fct-steps__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 84px;
}
.fct-steps__circle {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #29323f;
  border: 1.5px solid rgba(255, 255, 255, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.fct-steps__icon,
.fct-steps__check {
  position: absolute;
  width: 18px;
  height: 18px;
}
.fct-steps__check {
  opacity: 0;
}
.fct-steps__label {
  font-size: 10.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.38);
  text-align: center;
  letter-spacing: 0.01em;
  line-height: 1.3;
}
@media (prefers-reduced-motion: reduce) {
  .fct-steps__fill {
    width: 100%;
  }
  .fct-steps__icon {
    opacity: 0;
  }
  .fct-steps__check {
    opacity: 1;
  }
  .fct-steps__circle {
    background: #e3fd64;
    border-color: #e3fd64;
  }
}
.fct-widget {
  background: #29323f;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 20px 22px;
  animation: fct-up 0.6s ease 0.14s both;
}
.fct-widget__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.fct-widget__period {
  font-size: 11.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.38);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.fct-widget__badge {
  font-size: 10.5px;
  font-weight: 600;
  color: #16a34a;
  background: rgba(22, 163, 74, 0.12);
  padding: 3px 8px;
  border-radius: 20px;
}
.fct-widget__rows {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.fct-widget__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.fct-widget__row:last-child {
  border-bottom: none;
}
.fct-widget__row--total {
  padding-top: 12px;
  margin-top: 4px;
  border-bottom: none;
  border-top: 1px solid rgba(255, 255, 255, 0.08) !important;
}
.fct-widget__concept {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.48);
}
.fct-widget__amount {
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: rgba(255, 255, 255, 0.82);
}
.fct-widget__amount--pos {
  color: #4ade80;
}
.fct-widget__amount--neg {
  color: #f87171;
}
.fct-widget__row--total .fct-widget__concept {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
}
.fct-widget__row--total .fct-widget__amount {
  font-size: 15px;
  font-weight: 700;
  color: #e3fd64;
}
.fct-widget__sep {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 4px 0;
}
.fct-widget__progress {
  margin-top: 14px;
  height: 3px;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 999px;
  overflow: hidden;
}
.fct-widget__bar {
  height: 100%;
  background:
    linear-gradient(
      90deg,
      #e3fd64 0%,
      #f4fe9e 100%);
  border-radius: 999px;
  transform-origin: left;
  animation: fct-bar 1.1s cubic-bezier(0.16, 1, 0.3, 1) 0.7s both;
}
@keyframes fct-bar {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
.fct-widget__note {
  margin: 10px 0 0;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.28);
  display: flex;
  align-items: center;
  gap: 6px;
}
.fct-widget__dot {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e3fd64;
  flex-shrink: 0;
  animation: fct-blink 2s ease-in-out infinite;
}
@keyframes fct-blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}
.fct-trust {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 10.5px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.22);
  letter-spacing: 0.06em;
  animation: fct-up 0.6s ease 0.2s both;
}
.fct-trust__sep {
  opacity: 0.3;
}
.fct-form {
  flex: 1;
  background: #ffffff;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 48px 56px;
  overflow-y: auto;
}
@media (max-width: 860px) {
  .fct-form {
    background: #1d2530;
    padding: 40px 24px;
  }
}
@media (max-width: 480px) {
  .fct-form {
    padding: 32px 20px;
  }
}
.fct-form__inner {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 0;
  animation: fct-up 0.55s ease 0.1s both;
  padding: 16px 0 32px;
}
.fct-mobile-logo {
  display: none;
  height: 28px;
  width: auto;
  max-width: 140px;
  object-fit: contain;
  align-self: flex-start;
  margin-bottom: 32px;
}
@media (max-width: 860px) {
  .fct-mobile-logo {
    display: block;
  }
}
.fct-form__header {
  margin-bottom: 12px;
}
.fct-form__header-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}
.fct-header-login {
  margin: 0;
  font-size: 12.5px;
  color: #6b7280;
  white-space: nowrap;
}
@media (max-width: 860px) {
  .fct-header-login {
    color: rgba(255, 255, 255, 0.38);
  }
}
.fct-form__title {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
  line-height: 1.2;
}
@media (max-width: 860px) {
  .fct-form__title {
    color: rgba(255, 255, 255, 0.92);
  }
}
.fct-form__sub {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}
@media (max-width: 860px) {
  .fct-form__sub {
    color: rgba(255, 255, 255, 0.42);
  }
}
.fct-fields {
  display: grid;
}
.fct-field-group {
  display: flex;
  flex-direction: column;
}
.fct-field-group--full {
  grid-column: span 2;
}
.fct-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  display: block;
}
@media (max-width: 860px) {
  .fct-label {
    color: rgba(255, 255, 255, 0.7);
  }
}
.fct-label-hint {
  font-weight: 400;
  color: #9ca3af;
  font-size: 12px;
}
@media (max-width: 860px) {
  .fct-label-hint {
    color: rgba(255, 255, 255, 0.3);
  }
}
.fct-field-error {
  font-size: 12px;
  color: #dc2626;
  font-weight: 500;
}
@media (max-width: 860px) {
  .fct-field-error {
    color: #fca5a5;
  }
}
.fct-mat-field {
  width: 100%;
}
.fct-mat-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.fct-mat-field ::ng-deep .mdc-notched-outline__leading,
.fct-mat-field ::ng-deep .mdc-notched-outline__notch,
.fct-mat-field ::ng-deep .mdc-notched-outline__trailing {
  border-color: #e5e7eb !important;
}
.fct-mat-field ::ng-deep .mdc-text-field--outlined:hover:not(.mdc-text-field--focused):not(.mdc-text-field--disabled) .mdc-notched-outline__leading,
.fct-mat-field ::ng-deep .mdc-text-field--outlined:hover:not(.mdc-text-field--focused):not(.mdc-text-field--disabled) .mdc-notched-outline__notch,
.fct-mat-field ::ng-deep .mdc-text-field--outlined:hover:not(.mdc-text-field--focused):not(.mdc-text-field--disabled) .mdc-notched-outline__trailing {
  border-color: #9ca3af !important;
}
.fct-mat-field ::ng-deep .mdc-text-field--focused .mdc-notched-outline__leading,
.fct-mat-field ::ng-deep .mdc-text-field--focused .mdc-notched-outline__notch,
.fct-mat-field ::ng-deep .mdc-text-field--focused .mdc-notched-outline__trailing {
  border-color: #e3fd64 !important;
  border-width: 1.5px;
  box-shadow: 0 0 0 3px rgba(227, 253, 100, 0.28);
}
.fct-mat-field ::ng-deep .mat-mdc-floating-label {
  color: #6b7280;
  font-family: "Inter Tight", sans-serif;
}
.fct-mat-field ::ng-deep .mdc-text-field--focused .mat-mdc-floating-label {
  color: #e3fd64 !important;
}
.fct-mat-field ::ng-deep .mat-mdc-input-element {
  color: #0f172a;
  font-family: "Inter Tight", sans-serif;
  font-size: 14px;
}
.fct-mat-field ::ng-deep .mdc-text-field--outlined .mdc-notched-outline {
  height: 42px;
}
.fct-mat-field ::ng-deep .mat-mdc-form-field-infix {
  padding: 9px 0;
  min-height: 42px;
}
.fct-mat-field ::ng-deep .mat-mdc-text-field-wrapper {
  height: 42px;
}
.fct-mat-field ::ng-deep .mat-mdc-form-field-flex {
  height: 42px;
  align-items: center;
}
.fct-mat-field ::ng-deep .mat-mdc-form-field-text-suffix {
  display: flex;
  align-items: center;
  align-self: center;
}
@media (max-width: 860px) {
  .fct-mat-field ::ng-deep .mdc-notched-outline__leading,
  .fct-mat-field ::ng-deep .mdc-notched-outline__notch,
  .fct-mat-field ::ng-deep .mdc-notched-outline__trailing {
    border-color: rgba(255, 255, 255, 0.12) !important;
  }
  .fct-mat-field ::ng-deep .mat-mdc-input-element {
    color: rgba(255, 255, 255, 0.9);
  }
  .fct-mat-field ::ng-deep .mat-mdc-floating-label {
    color: rgba(255, 255, 255, 0.45);
  }
}
.fct-pw-toggle {
  color: #9ca3af !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  transition: color 0.15s;
}
.fct-pw-toggle:hover {
  color: #e3fd64 !important;
}
.fct-pw-toggle .mat-icon {
  font-size: 20px;
  line-height: 20px;
  width: 20px;
  height: 20px;
}
@media (max-width: 860px) {
  .fct-pw-toggle {
    color: rgba(255, 255, 255, 0.4) !important;
  }
  .fct-pw-toggle:hover {
    color: #e3fd64 !important;
  }
}
.fct-link {
  font-size: 12.5px;
  font-weight: 500;
  color: #6b7280;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: "Inter Tight", sans-serif;
  text-decoration: none;
  transition: color 0.15s;
}
.fct-link:hover {
  color: #e3fd64;
}
.fct-link--accent {
  color: #e3fd64;
  font-weight: 600;
}
.fct-link--accent:hover {
  color: #4d7a00;
}
@media (max-width: 860px) {
  .fct-link {
    color: rgba(255, 255, 255, 0.45);
  }
  .fct-link:hover {
    color: #e3fd64;
  }
}
.fct-checks {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}
.fct-remember {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.fct-check__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.fct-check__input:checked + .fct-check__box {
  background: #e3fd64;
  border-color: #e3fd64;
}
.fct-check__input:checked + .fct-check__box::after {
  opacity: 1;
  transform: scale(1) rotate(-5deg);
}
.fct-check__input:focus-visible + .fct-check__box {
  outline: 2px solid #e3fd64;
  outline-offset: 2px;
}
.fct-check__box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: 4px;
  border: 1.5px solid #d1d5db;
  background: #ffffff;
  flex-shrink: 0;
  margin-top: 1px;
  transition: background 0.15s, border-color 0.15s;
}
.fct-check__box::after {
  content: "";
  display: block;
  width: 9px;
  height: 6px;
  border-left: 1.5px solid #fff;
  border-bottom: 1.5px solid #fff;
  transform: scale(0) rotate(-5deg);
  transform-origin: center;
  opacity: 0;
  transition: opacity 0.12s, transform 0.12s;
  margin-top: -2px;
}
@media (max-width: 860px) {
  .fct-check__box {
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.05);
  }
}
.fct-check__text {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.45;
}
@media (max-width: 860px) {
  .fct-check__text {
    color: rgba(255, 255, 255, 0.55);
  }
}
.fct-lopd {
  font-size: 11.5px;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0 0 22px;
  padding: 12px 14px;
  background: #f9fafb;
  border-radius: 8px;
  border-left: 2px solid #e5e7eb;
}
.fct-lopd strong {
  color: #4b5563;
  font-weight: 600;
}
@media (max-width: 860px) {
  .fct-lopd {
    background: rgba(255, 255, 255, 0.04);
    border-left-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.28);
  }
}
.fct-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  height: 46px;
  background: #e3fd64;
  color: rgba(0, 0, 0, 0.85);
  border: none;
  border-radius: 8px;
  font-size: 14.5px;
  font-weight: 600;
  font-family: "Inter Tight", sans-serif;
  cursor: pointer;
  transition:
    background 0.18s,
    box-shadow 0.18s,
    transform 0.12s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 4px 16px rgba(227, 253, 100, 0.3);
  letter-spacing: -0.01em;
}
.fct-submit:hover:not(:disabled) {
  background: #4d7a00;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(227, 253, 100, 0.42);
  transform: translateY(-1px);
}
.fct-submit:active:not(:disabled) {
  transform: translateY(0) scale(0.99);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.fct-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}
.fct-submit--loading {
  pointer-events: none;
}
.fct-submit__arrow {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  transition: transform 0.18s;
}
.fct-submit:hover .fct-submit__arrow {
  transform: translateX(3px);
}
.fct-dots {
  display: flex;
  align-items: center;
  gap: 5px;
}
.fct-dots span {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  animation: fct-pulse 1.1s ease-in-out infinite;
}
.fct-dots span:nth-child(2) {
  animation-delay: 0.18s;
}
.fct-dots span:nth-child(3) {
  animation-delay: 0.36s;
}
.fct-dots--dark span {
  background: #e3fd64;
}
@keyframes fct-pulse {
  0%, 80%, 100% {
    opacity: 0.35;
    transform: scale(0.85);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.fct-form__footer {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #f3f4f6;
  padding-top: 20px;
}
@media (max-width: 860px) {
  .fct-form__footer {
    border-top-color: rgba(255, 255, 255, 0.08);
  }
}
.fct-register {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 5px;
}
@media (max-width: 860px) {
  .fct-register {
    color: rgba(255, 255, 255, 0.38);
  }
}
@media (max-width: 480px) {
  .fct-fields {
    grid-template-columns: 1fr;
  }
  .fct-field-group--full {
    grid-column: span 1;
  }
}
.fct-processing {
  position: fixed;
  inset: 0;
  background: rgba(12, 18, 25, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  animation: fct-fade 0.25s ease;
}
.fct-processing__card {
  background: #ffffff;
  border-radius: 20px;
  padding: 40px 48px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  animation: fct-up 0.3s ease both;
  max-width: 320px;
  width: 90%;
}
.fct-processing__icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fct-processing__icon svg {
  width: 100%;
  height: 100%;
}
.fct-processing__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}
.fct-processing__sub {
  margin: 0;
  font-size: 13.5px;
  color: #6b7280;
  line-height: 1.6;
}
.fct-success {
  position: fixed;
  inset: 0;
  background: rgba(12, 18, 25, 0.8);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  animation: fct-fade 0.3s ease;
}
.fct-success__card {
  background: #ffffff;
  border-radius: 20px;
  padding: 44px 52px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  animation: fct-up 0.35s ease both;
  max-width: 380px;
  width: 90%;
}
.fct-success__icon {
  width: 64px;
  height: 64px;
}
.fct-success__icon svg {
  width: 100%;
  height: 100%;
}
.fct-success__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
}
.fct-success__sub {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
}
@keyframes fct-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fct-up {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*# sourceMappingURL=register.component.css.map */
